import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import {
  AIAssessment,
  AIAssessmentRequest,
  AIAssessmentResponse,
} from './types'
import { $params } from '../../../features/router'

export const assessmentMounted = createEvent()

export const setAssessment = createEvent<AIAssessment>()

export const submitUpdateAssessment = createEvent<AIAssessment>()

export const $assessment = restore(setAssessment, {
  gain: '',
  winRate: '',
  activeDays: '',
  risk: '',
  profit: '',
  loss: '',
  investors: '',
})

export const updateAssessment = fx<AIAssessmentRequest, AIAssessmentResponse>({
  method: 'POST',
  url: '/ai_assessment',
})

export const getAssessment = fx<AIAssessmentRequest, AIAssessmentResponse>({
  method: 'GET',
  url: '/ai_assessment',
})

sample({
  clock: assessmentMounted,
  source: $params,
  fn: () => {
    let query = {}
    // @ts-ignore
    query['order'] = '-id'
    return {
      query,
    }
  },
  target: getAssessment,
})

sample({
  // @ts-ignore
  clock: submitUpdateAssessment,
  source: $params,
  fn: (params, assessment) => {
    return {
      url: `/ai_assessment`,
      body: { ...assessment },
    }
  },
  target: updateAssessment,
})

sample({
  clock: [getAssessment.doneData, updateAssessment.doneData],
  fn: (doneData) => doneData.body.items[0],
  target: setAssessment,
})
